import React from "react";
import {Route, Redirect} from "react-router-dom";

export default (props) => {

    const renderMergedProps = (component, ...rest) => {
        const finalProps = Object.assign({}, ...rest);
        return (
            React.createElement(component, finalProps)
        );
    }

   /* const PropsRoute = ({ component, ...rest }) => {
        return (
            <Route {...rest} render={routeProps => {
                return renderMergedProps(component, routeProps, rest);
            }}/>
        );
    }*/

    const {component: C, isAuthenticated, ...rest} = props;
   // console.log('===> isAuthenticated', props);

     if(!isAuthenticated) {
         window.location.href = "/?login=" + window.location.pathname;
         return null;
     }

    return (
        <Route
            {...rest}
            render={ routeProps  =>
                    renderMergedProps(C, routeProps, rest)
            }
            />

    )
}

